<template>
	<div>
		<h5 class="header pt-4">Add Money</h5>
		<div class="pa-4">
			<div>
				<v-text-field
					label="Amount"
					placeholder="Enter Amount"
					v-model="amountToAdd"
					class="text-field-wrapper pt-4"
					:rules="[onlyDigitsRule]"
				></v-text-field>
			</div>
			<div class="error--text text-caption pl-2" v-if="!isValidAmount">
				Amount cannot be greater than the credits used
			</div>
			<div class="d-flex pt-3">
				<v-btn
					large
					:color="themeInputColor"
					class="white--text btn rounded-pill"
					:loading="isLoading"
					@click="addMoney"
					prepend-icon="account_balance_wallet"
					:disabled="
						!amountToAdd ||
							!isValidAmount ||
							checkingStatus ||
							/\D/g.test(amountToAdd)
					"
					>Add Money</v-btn
				>
			</div>
		</div>
		<div v-if="checkingStatus" class="pt-4">
			<v-layout class="pb-2 justify-center">
				<v-flex class="d-flex justify-center">
					<v-progress-circular
						indeterminate
						v-bind:size="30"
						color="green pa-2 mr-2"
					></v-progress-circular>
				</v-flex>
			</v-layout>
			<v-layout class="align-center">
				<v-flex xs12 class="text-center">
					<div class="px-3">
						Confirming the payment of your app. Do not press any
						button.
					</div>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
import { themeInputColor, _onlyDigitsRule } from "@/utils";
export default {
	name: "AddMoney",
	props: ["isLoading", "checkingStatus", "creditUsed", "isShareChatAgency"],
	data() {
		return {
			themeInputColor,
			amountToAdd: null,
			onlyDigitsRule: _onlyDigitsRule
		};
	},
	computed: {
		isValidAmount() {
			return (
				!this.isShareChatAgency ||
				this.amountToAdd === null ||
				this.amountToAdd <= this.creditUsed
			);
		}
	},
	methods: {
		addMoney() {
			this.$emit(
				"ADD_MONEY",
				Math.round(Number(this.amountToAdd) * 100) / 100
			);
		}
	}
};
</script>
<style scoped>
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	line-height: 21px;
	padding: 1em;
	text-align: center;
	letter-spacing: 0.004em;
}
</style>
